import { createRouter, createWebHistory } from "vue-router";
import InputForm from "@components/templates/dxShukkinbo/input/dx-shukkinbo-input.vue";
import Confirmation from "@components/templates/dxShukkinbo/confirm/dx-shukkinbo-confirm.vue";
import Complete from "@components/templates/dxShukkinbo/complete/dx-shukkinbo-complete.vue";
import ErrorPage from "@/components/common/error-page/error-page.vue";

const routes = [
  {
    path: "/",
    component: InputForm,
    props: (route) => ({
      serviceName: route.query.serviceName,
      soParam01: route.query.soParam01,
      soParam02: route.query.soParam02,
    }),
  },
  { path: "/index.html", redirect: "/" },
  { path: "/error", component: ErrorPage },
  { path: "/confirmation", component: Confirmation },
  { path: "/complete", component: Complete },
];
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
export default router;
